import Modal from './Modal';
import Button from '../Base/Button/Button';
import { useEffect, useState } from 'react';

export default function DomModal(props) {
	const { openedCallback, children } = props;
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		openedCallback(setVisible);
	}, []);

	return (
		<Modal opened={visible}>
			<Modal.Header title='kalendář' />
			<Modal.Content>
				<Button text={'asd'} />
				{children}
			</Modal.Content>
		</Modal>
	);
}
